import { render, staticRenderFns } from "./lkuAssetlocat.vue?vue&type=template&id=1fedc0a4"
import script from "./lkuAssetlocat.vue?vue&type=script&lang=js"
export * from "./lkuAssetlocat.vue?vue&type=script&lang=js"
import style0 from "./lkuAssetlocat.vue?vue&type=style&index=0&id=1fedc0a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports